import { SEXPR_OPERATORS } from '../../Filters/sexpr';
import {
  Filterable,
  isRangeOperator,
  TConditionOperator,
} from '../../Filters/types';

// the final rating is filtered through its displayed text (e.g. "3 final
// rating", "Not eligible for rating"), which also supports typed numbers
// and the range operators for the rows holding an actual rating
export const FINAL_RATING_TEXT_FILTER_KEY = 'final_rating_text';

// maps the text of each actual rating found in the rows to its number, so
// that a text suggestion can be used as the bound of a range
export const buildFinalRatingTextToNumber = (
  rows: { final_rating?: unknown; final_rating_text?: unknown }[] | undefined
): Record<string, number> => {
  const textToNumber: Record<string, number> = {};
  for (const row of rows ?? []) {
    if (
      typeof row.final_rating === 'number' &&
      typeof row.final_rating_text === 'string'
    ) {
      textToNumber[row.final_rating_text] = row.final_rating;
    }
  }
  return textToNumber;
};

const isNumericText = (text: string): boolean =>
  text.trim() !== '' && !Number.isNaN(Number(text));

// typed numbers and ranges compare against the rating itself: rows without
// an actual rating (not eligible, not yet complete...) hold a placeholder
// string there, which never satisfies a numeric comparison; anything else
// compares against the displayed text
export const getFinalRatingFieldTransformer =
  (textToNumber: Record<string, number>) =>
  (value: Filterable, operator: TConditionOperator): string => {
    const filterValue = value.filterObject.value;
    if (isRangeOperator(operator)) {
      return `(${SEXPR_OPERATORS[operator]} final_rating "${
        textToNumber[filterValue] ?? filterValue
      }")`;
    }
    const field = isNumericText(filterValue)
      ? 'final_rating'
      : FINAL_RATING_TEXT_FILTER_KEY;
    return `(${SEXPR_OPERATORS[operator]} ${field} "${filterValue}")`;
  };
